export default {
  industries: [],
}
